import { Injectable } from '@angular/core';
import { FeatureFlagsRulesService, Http, QueryBus, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { SaleProFormaRepositoryBase } from '@skylab-shared/business';
import { ClientRepository } from '../client/client.repo';
import { ProductRepository } from '../product/product.repo';
export { SaleProFormaRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(SaleProFormaRepositoryBase)
export class SaleProFormaRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
        productRepository: ProductRepository,
        clientRepository: ClientRepository,
        queryBus: QueryBus,
        featureFlagsRulesService: FeatureFlagsRulesService
    ) { }
}
